import { foundationCalendarStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
export const zeroCalendarStyles = () => css `
  ${foundationCalendarStyles()}
`;
